import { parseDomain, ParseResultType } from 'parse-domain'

export const getBaseDomain = (hostname: string): string | null => {
  if (!hostname) return null

  const parseResult = parseDomain(hostname)
  if (parseResult.type === ParseResultType.Listed) {
    const tld = parseResult.topLevelDomains.join('.')
    const domain = parseResult.domain

    if (!tld || !domain) return null

    return `${domain}.${tld}`
  }
  return null
}

export const getSubdomain = (hostname: string): string | null => {
  if (!hostname) return null

  const parseResult = parseDomain(hostname)
  if (parseResult.type === ParseResultType.Listed) {
    return parseResult.subDomains.join('.') || null
  }
  return null
}

/**
 * Extract host prefix from domain with subdomains.
 * Example:
 *   hostname: 'test.subdomain.domain.com'
 *   domain: 'domain.com'
 *   result: 'test.subdomain'
 * @param hostname
 * @param domain
 */
export const extractHostPrefix = (hostname: string, domain: string): string => {
  if (!hostname.endsWith(domain)) return hostname

  const suffix = `.${domain}`
  return hostname.slice(0, -suffix.length)
}

/**
 * Valid domain must be listed and have not empty tld and domain name
 * @param hostname
 */
export const isValidDomain = (hostname?: string | null): boolean => {
  if (!hostname) {
    return false
  }

  const parsedResult = parseDomain(hostname)

  return Boolean(
    parsedResult.type === ParseResultType.Listed && parsedResult.topLevelDomains.length && parsedResult.domain,
  )
}
